var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LayoutComponentDisplay } from "@/components/forms/components/layout/layoutComponentDisplay";
import copy from "fast-copy";
import { useEffect, useState } from "react";
import { UserPassword } from "./userPassword";
import { Advanced } from "./advanced";
import { useGetCurrentUserQuery, useSendTestEmailMutation, useGetEmailConfigQuery, } from "@/store/api";
import { useTranslation } from "react-i18next";
import { get_current_language, scrollToEl, } from "@/components/forms/components/utils";
import DisplayField from "@/components/fields/displayField";
import { FieldViewType, screenViewType } from "@/components/fields/viewType";
import { Input } from "@mui/joy";
import qs from "qs";
import toast from "react-hot-toast";
export var UserProfile = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var module = _a.module, viewType = _a.viewType, field_defs = _a.field_defs, record = _a.record, layoutMeta = _a.layoutMeta, view = _a.view, setRecord = _a.setRecord, passwordValue = _a.passwordValue, advancedSettings = _a.advancedSettings, layoutPwdCreation = _a.layoutPwdCreation;
    var t = useTranslation(["Users"]).t;
    var _l = useState(0), selectedIndex = _l[0], setSelectedIndex = _l[1];
    var _m = useState(copy(record)), editedRecord = _m[0], setEditedRecord = _m[1];
    var _o = useState(new Map()), validations = _o[0], setValidations = _o[1];
    var updateRecordOLD = function (edited) {
        setEditedRecord(edited);
        setRecord(edited);
    };
    var updateRecord = function (updatedFields) {
        var newRecord = __assign(__assign({}, editedRecord), updatedFields);
        setEditedRecord(newRecord);
        setRecord(newRecord);
    };
    var getPassData = function (value) {
        if (!layoutPwdCreation && isAdminCreation)
            return;
        passwordValue(value);
        setEditedRecord(__assign(__assign({}, editedRecord), { password: value }));
    };
    // L'onglet password n'est pas éditable que pour l'utilisateur courant
    var queryResult = useGetCurrentUserQuery(null, {
        refetchOnMountOrArgChange: true,
    }).data;
    var currentUser = ((_c = (_b = queryResult === null || queryResult === void 0 ? void 0 : queryResult.data) === null || _b === void 0 ? void 0 : _b.record) === null || _c === void 0 ? void 0 : _c.attributes) || {};
    var isAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.is_admin) === "1";
    var isOwnProfile = (record === null || record === void 0 ? void 0 : record.id) && record.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
    var isAdminCreation = !(record === null || record === void 0 ? void 0 : record.id) && isAdmin;
    var showPasswordTab = (isAdminCreation && layoutPwdCreation) || isOwnProfile;
    var tabHeaders = __spreadArray(__spreadArray([
        t("LBL_USER_INFORMATION")
    ], (showPasswordTab ? [t("LBL_PASSWORD")] : []), true), [
        t("LBL_ADVANCED"),
    ], false);
    //record.id !== currentUser.id && tabHeaders.splice(1, 1);
    var locale_config = ((_e = (_d = queryResult === null || queryResult === void 0 ? void 0 : queryResult.data) === null || _d === void 0 ? void 0 : _d.preferences) === null || _e === void 0 ? void 0 : _e.locale_config) || [];
    var advanced_user_config = ((_g = (_f = queryResult === null || queryResult === void 0 ? void 0 : queryResult.data) === null || _f === void 0 ? void 0 : _f.preferences) === null || _g === void 0 ? void 0 : _g.advanced_user_settings) || [];
    useEffect(function () {
        var el = document.getElementById("detailForm");
        el && scrollToEl(el);
    }, [selectedIndex]);
    var updateAdvancedConfigs = function (settings) {
        advancedSettings(settings);
        setEditedRecord(__assign(__assign({}, editedRecord), { advanced: settings }));
    };
    var emailOptionsSettingsFieldDef = {
        email1: field_defs.email1,
        email_link_type: field_defs.email_link_type,
    };
    var userType = editedRecord.is_admin === "1"
        ? "Administrator"
        : editedRecord.is_group === "1"
            ? "GROUP"
            : "RegularUser";
    var _p = useState({
        notify_fromname: editedRecord.user_name || "",
        notify_fromaddress: editedRecord.email1 || "",
        mail_smtpserver: "",
        mail_smtpport: 25,
        mail_sendtype: "smtp",
        mail_smtptype: "other",
        mail_smtpuser: editedRecord.mail_smtpuser || "",
        mail_smtppass: editedRecord.mail_smtppass || "",
        mail_smtpauth_req: false,
        mail_smtpssl: 0,
        notify_allow_default_outbound: true,
        notify_on: false,
        notify_send_from_assigning_user: false,
    }), settings = _p[0], setSettings = _p[1];
    var fieldsParam = {
        settings: settings,
    };
    var queryString = qs.stringify({ lang: get_current_language() || "en_US", fields: fieldsParam }, { arrayFormat: "brackets" });
    var _q = useGetEmailConfigQuery({ params: queryString }), data = _q.data, loadEmail = _q.isLoading, error = _q.error;
    var settingsOutBound = (_j = (_h = data === null || data === void 0 ? void 0 : data.data) === null || _h === void 0 ? void 0 : _h.configs) === null || _j === void 0 ? void 0 : _j.settings;
    var _r = useSendTestEmailMutation(), sendTestEmail = _r[0], loadingTestEmail = _r[1].isLoading;
    var handleSendTestEmail = function () { return __awaiter(void 0, void 0, void 0, function () {
        var primaryEmail, emailParams, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    primaryEmail = Array.isArray(editedRecord.email1)
                        ? (_a = editedRecord.email1.find(function (e) { return e.primary_address; })) === null || _a === void 0 ? void 0 : _a.email_address
                        : editedRecord.email1;
                    if (!primaryEmail) {
                        toast.error("The administrator has not yet configured the default outbound account. Unable to send test email.");
                        return [2 /*return*/];
                    }
                    emailParams = {
                        fromaddress: settings.notify_fromaddress || primaryEmail,
                        toAddress: primaryEmail,
                        mail_smtpserver: settings.mail_smtpserver || (settingsOutBound === null || settingsOutBound === void 0 ? void 0 : settingsOutBound.mail_smtpserver) || "",
                        mail_smtpport: settings.mail_smtpport || (settingsOutBound === null || settingsOutBound === void 0 ? void 0 : settingsOutBound.mail_smtpport) || 25,
                        mail_smtpssl: settings.mail_smtpssl || (settingsOutBound === null || settingsOutBound === void 0 ? void 0 : settingsOutBound.mail_smtpssl) || 0,
                        mail_smtpauth_req: (_b = settingsOutBound === null || settingsOutBound === void 0 ? void 0 : settingsOutBound.mail_smtpauth_req) !== null && _b !== void 0 ? _b : false,
                        mail_smtpuser: settings.mail_smtpuser || (settingsOutBound === null || settingsOutBound === void 0 ? void 0 : settingsOutBound.mail_smtpuser) || "",
                        mail_smtppass: settings.mail_smtppass || "",
                        mail_sendtype: settings.mail_sendtype || "smtp",
                        notify_fromname: settings.notify_fromname || editedRecord.user_name,
                        mail_type: "system",
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, sendTestEmail({
                            body: { params: emailParams },
                        }).unwrap()];
                case 2:
                    _c.sent();
                    toast.success("Email sent!");
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "flex flex-col w-full", id: "user-profile" }, { children: [_jsx("div", __assign({ className: "w-full bg-gray-200 pl-2 py-2 border-dashed relative" }, { children: _jsx("ul", __assign({ className: "flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200" }, { children: tabHeaders.map(function (item, i) { return (_jsx("li", __assign({ className: "mr-2 cursor-pointer", onClick: function (e) {
                            e.stopPropagation();
                            setSelectedIndex(i);
                        } }, { children: _jsx("span", __assign({ className: "inline-block p-4 ".concat(i === selectedIndex
                                ? "text-blue-600 bg-gray-100 rounded-t-lg"
                                : "rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300") }, { children: item })) }), "".concat(i))); }) })) })), _jsxs("div", { children: [selectedIndex === 0 && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "mt-4" }, { children: _jsx(LayoutComponentDisplay, { module: module, viewType: viewType, fieldDefs: field_defs, record: editedRecord, fetchedRecord: record, layouts: (layoutMeta === null || layoutMeta === void 0 ? void 0 : layoutMeta.layout) || [], onHandleUpdate: updateRecord, validations: validations, viewScreen: view }) })), userType !== "GROUP" && (_jsxs("div", __assign({ className: "mt-6 border rounded p-4 bg-gray-50" }, { children: [_jsx("h4", __assign({ className: "text-lg font-semibold mb-4" }, { children: "Email Settings" })), emailOptionsSettingsFieldDef &&
                                        ((_k = Object.values(emailOptionsSettingsFieldDef)) === null || _k === void 0 ? void 0 : _k.map(function (field) { return (_jsx(DisplayField, { moduleName: module, fieldName: field === null || field === void 0 ? void 0 : field.name, fieldLabel: t(field === null || field === void 0 ? void 0 : field.vname), record: editedRecord, fieldDef: field, fieldMetadata: field, viewType: FieldViewType.EDIT, viewScreen: screenViewType.EDITVIEW, validations: validations, onUpdate: updateRecord }, field.name)); })), _jsxs("div", __assign({ className: "flex items-center gap-4 py-2" }, { children: [_jsx("label", __assign({ className: "w-48" }, { children: t("LBL_EMAIL_PROVIDER") })), _jsx("span", { children: editedRecord.mail_smtpdisplay || "" })] })), editedRecord.is_group === "0" && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex items-center gap-4 py-1" }, { children: [_jsx("label", __assign({ className: "w-36 first-letter:capitalize text-[var(--colors-label)] mb-2" }, { children: t("LBL_MAIL_SMTPUSER") })), _jsx(Input, { type: "text", value: editedRecord.mail_smtpuser || "", size: "sm", onChange: function (e) {
                                                            return updateRecord({
                                                                mail_smtpuser: e.target.value,
                                                            });
                                                        }, className: "border px-2 py-1 w-64 mb-2" })] })), _jsxs("div", __assign({ className: "flex items-center gap-4 py-1" }, { children: [_jsx("label", __assign({ className: "w-36 first-letter:capitalize text-[var(--colors-label)]" }, { children: t("LBL_MAIL_SMTPPASS") })), _jsx(Input, { type: "password", value: editedRecord.mail_smtppass || "", size: "sm", onChange: function (e) {
                                                            return updateRecord({
                                                                mail_smtppass: e.target.value,
                                                            });
                                                        }, className: "border px-2 py-1 w-64" })] }))] })), _jsx("div", __assign({ className: "mt-4" }, { children: _jsx("button", __assign({ className: "button primary", onClick: function () {
                                                handleSendTestEmail();
                                            } }, { children: "Send test email" })) }))] })))] })), selectedIndex === (showPasswordTab ? 1 : -1) && (_jsx(_Fragment, { children: _jsx(UserPassword, { passData: getPassData, record: editedRecord, isAdminCreation: isAdminCreation, generatePwd: layoutPwdCreation }) })), selectedIndex === (showPasswordTab ? 2 : 1) && (_jsx(_Fragment, { children: _jsx(Advanced, { preferences: { locale_config: locale_config, advanced_user_config: advanced_user_config }, user: currentUser, onUpdatePreferences: updateAdvancedConfigs }) }))] })] })));
};
